var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 250 200"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ECFDF5",
  fillRule: "evenodd",
  d: "M63 134h91q.774-.002 1.5-.161.726.16 1.5.161h52a7 7 0 1 0 0-14h-6a7 7 0 1 1 0-14h19a7 7 0 1 0 0-14h-22a7 7 0 1 0 0-14h-64a7 7 0 1 0 0-14H79a7 7 0 1 0 0 14H39a7 7 0 1 0 0 14h25a7 7 0 1 1 0 14H24a7 7 0 1 0 0 14h39a7 7 0 1 0 0 14m163 0a7 7 0 1 0 0-14 7 7 0 0 0 0 14",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#047857",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M172.5 45v6M172.5 59v6M162.5 55h6M176.5 55h6M89.5 148v4M89.5 160v4M81.5 156h4M93.5 156h4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#047857",
  fillRule: "evenodd",
  d: "M181 90.326c2.57-.802 6.509-3.945 7.421-7.326.827 2.99 4.293 6.524 7.42 6.792-3.52 1.246-6.886 4.95-7.42 7.859-.364-2.965-5.019-6.893-7.421-7.325M64 144.326c2.57-.802 6.509-3.945 7.42-7.326.828 2.989 4.294 6.524 7.421 6.792-3.52 1.246-6.886 4.95-7.42 7.859-.364-2.965-5.02-6.893-7.421-7.325",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M160.711 131.126a45.5 45.5 0 0 0 9.023-18.229 46.2 46.2 0 0 0 1.16-13.867 46 46 0 0 0-2.429-11.97 45.8 45.8 0 0 0-5.59-11.045 46.5 46.5 0 0 0-4.841-5.911 46.3 46.3 0 0 0-8.632-7.025 45.9 45.9 0 0 0-10.476-4.88 46.24 46.24 0 0 0-25.024-.886 45.6 45.6 0 0 0-11.725 4.656 45.9 45.9 0 0 0-9.189 6.886 45.7 45.7 0 0 0-8.637 11.444 45.7 45.7 0 0 0-4.514 12.79 46.3 46.3 0 0 0-.558 13.829 46 46 0 0 0 5.485 17.261 46.3 46.3 0 0 0 7.202 9.717 46 46 0 0 0 15.638 10.639 46.2 46.2 0 0 0 21.861 3.265 45.7 45.7 0 0 0 17.896-5.51",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#064E3B",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3,
  d: "M160.711 131.126a45.5 45.5 0 0 0 9.023-18.229 46.2 46.2 0 0 0 1.16-13.867 46 46 0 0 0-2.429-11.97 45.8 45.8 0 0 0-5.59-11.045 46.5 46.5 0 0 0-4.841-5.911 46.3 46.3 0 0 0-8.632-7.025 45.9 45.9 0 0 0-10.476-4.88 46.24 46.24 0 0 0-25.024-.886 45.6 45.6 0 0 0-11.725 4.656 45.9 45.9 0 0 0-9.189 6.886 45.7 45.7 0 0 0-8.637 11.444 45.7 45.7 0 0 0-4.514 12.79 46.3 46.3 0 0 0-.558 13.829 46 46 0 0 0 5.485 17.261 46.3 46.3 0 0 0 7.202 9.717 46 46 0 0 0 15.638 10.639 46.2 46.2 0 0 0 21.861 3.265 45.7 45.7 0 0 0 17.896-5.51"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M150.701 140.378c2.906-1.87 5.49-4.203 7.171-6.087z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#064E3B",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M150.701 140.378c2.906-1.87 5.49-4.203 7.171-6.087"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#ECFDF5",
  d: "M167 104.617q-.43.008-.86.008c-25.254 0-45.931-19.689-47.664-44.625C98.376 63.17 83 80.653 83 101.743 83 125.081 101.825 144 125.048 144c22.261 0 40.482-17.385 41.952-39.383"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#10B981",
  fillRule: "evenodd",
  stroke: "#064E3B",
  strokeLinecap: "round",
  strokeWidth: 3,
  d: "M109.023 100.373a2.977 2.977 0 0 0-4.238.194 3.055 3.055 0 0 0 .192 4.284l14.119 13.038a4.17 4.17 0 0 0 5.933-.271c.066-.074.066-.074.129-.149l20.149-24.497a3.056 3.056 0 0 0-.389-4.271 2.98 2.98 0 0 0-4.225.393l-18.943 23.031z",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M112.824 66.413a40 40 0 0 0-5.696 2.668 40.1 40.1 0 0 0-8.038 6.024q-1.522 1.471-2.855 3.056m-2.75 3.677a40 40 0 0 0-3.174 5.79",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#047857",
  d: "M113.351 67.818a1.5 1.5 0 0 0-1.054-2.81zm-6.223 1.263.742 1.303zm-8.038 6.024-1.042-1.08zm-4.003 2.09a1.5 1.5 0 0 0 2.296 1.932zm-.351 5.47a1.5 1.5 0 1 0-2.502-1.655zm-3.202 2.453 1.325.704zm-2.594 1.901a1.5 1.5 0 0 0 2.741 1.219zm23.357-22.01c-2.024.759-4 1.681-5.91 2.768l1.483 2.607a38 38 0 0 1 5.481-2.567zm-5.91 2.768a41.6 41.6 0 0 0-8.34 6.249l2.085 2.158a38.6 38.6 0 0 1 7.738-5.8zm-8.34 6.249a42 42 0 0 0-2.96 3.17l2.296 1.93q1.283-1.525 2.749-2.942zm-5.813 6.984a41 41 0 0 0-2.024 3.404l2.649 1.408a38 38 0 0 1 1.877-3.156zm-2.024 3.404a41 41 0 0 0-1.27 2.605l2.741 1.219q.545-1.225 1.178-2.416z"
})));
export default SvgDone;